import AbstractService from "./AbstractService";
import store from "../store/store";

export default class DailyReportService extends AbstractService {
  url(url) {
    return `/dailyReport${url}`;
  }
  async getMissingReports(reference) {
    const data = await this.http.get(this.url(`/${reference}`));
    return data;
  }

  async saveReportCard(model) {
    return await this.http.post(this.url("/save"), model);
  }

  async updateReportCard(model) {
    return await this.http.post(this.url("/save"), model);
  }

  async getReportsByUserRef(reference) {
    let data;
    data = await this.http.get(this.url(`/report/${reference}`));

    return data;
  }
  async getReports(reference) {
    let data;
    data = await this.http.get(this.url("/"));

    return data;
  }

  async getPendingReports() {
    const data = await this.http.get(this.url("/report/pending"));
    return data;
  }

  async deletePendingReports(userIds) {
    const data = await this.http.delete(this.url(`/report/delete/${userIds}`));
    return data.status;
  }

  async personDailyReport(obj, userName) {
    const params = obj;
    const data = await this.http.get(this.url("/report/person"), { params });
    const report = data.data;
    report.userName = userName;
    await store.dispatch("setReportCard", report);
  }

  _modelToQuery(model) {
    const query = Object.assign({}, model);
    return query;
  }
}
